<template>
    <div class="loader-container">
        <div class="loader"></div>
    </div>
</template>

<script>
export default {
    name : "loader"
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/partials/loader.vue